import React, { useContext, useState } from 'react'
import { Button, ButtonGroup, Col, Row } from 'reactstrap'
import DevModeToggle from '../DevModeToggle'
import { store } from '../../stores/pages'
import UpdatePublishedModal from './UpdatePublishedModal'

export default function PageActions() {
  const {
    admin,
    page,
    saveUrl,
    saving,
    viewingPreview,
    viewingContentEditor,
    showPublish,
    refreshing,
    cancelLink,
    dispatch,
    actions,
  } = useContext(store)

  const { devMode } = admin || false

  const [updatePublishedOpen, setUpdatePublishedOpen] = useState(false)

  const savePage = () => {
    if (page && page.attributes.published) {
      setUpdatePublishedOpen(true)
    } else {
      dispatch({ type: actions.SAVE_PAGE })
    }
  }

  const updateDevMode = (newDevMode) => {
    dispatch({ type: actions.UPDATE_DEV_MODE, payload: newDevMode })
  }

  const showContentEditor = () => {
    dispatch({ type: actions.SHOW_CONTENT_EDITOR })
  }

  const showPreview = () => {
    dispatch({ type: actions.SHOW_PREVIEW })
  }

  const disabled = refreshing || saving

  const saveButtonText = saving ? 'Saving…' : (
    page ? (page.attributes.published ? 'Update Published Page' : 'Save as Draft') : 'Save Theme'
  )

  return (
    <Row className="producer-content-actions align-items-center">
      <Col xs="12" md="auto" className={admin ? '' : 'me-auto'}>
        <ButtonGroup className="w-100">
          <Button onClick={showContentEditor} disabled={disabled} color={viewingContentEditor ? 'primary' : 'outline-secondary'}>Edit Content</Button>
          <Button onClick={showPreview} disabled={disabled} color={viewingPreview ? 'primary' : 'outline-secondary'}>Preview{showPublish && ' & Publish'}</Button>
        </ButtonGroup>
      </Col>
      {admin && (
        <Col className="me-auto d-none d-md-block">
          <DevModeToggle onChange={updateDevMode} devMode={devMode} className="mb-0" />
        </Col>
      )}
      {saveUrl ? (
        <Col xs="8" md="auto" className="ps-md-0 mt-3 mt-md-0">
          <Button block color="primary" disabled={disabled} onClick={savePage}>{saving ? 'Saving…' : saveButtonText }</Button>
          {page && page.attributes && page.attributes.published  && <UpdatePublishedModal isOpen={updatePublishedOpen} close={() => setUpdatePublishedOpen(false)} />}
        </Col>
      ) : null}
      {cancelLink ? (
        <Col xs="4" md="auto" className="ps-md-0 mt-3 mt-md-0">
          <a href={cancelLink} className="btn w-100 btn-outline-secondary">Cancel</a>
        </Col>
      ) : null}
    </Row>
  )
}
